import { action } from 'satcheljs';

// Dispatched specifically when the Copilot Chat Drawer is opened
export const onCopilotChatDrawerOpened: () => {} = action('onCopilotChatDrawerOpened');
